import { render, staticRenderFns } from "./TitleEditor.vue?vue&type=template&id=57ce35c8"
import script from "./TitleEditor.vue?vue&type=script&lang=js"
export * from "./TitleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ce35c8')) {
      api.createRecord('57ce35c8', component.options)
    } else {
      api.reload('57ce35c8', component.options)
    }
    module.hot.accept("./TitleEditor.vue?vue&type=template&id=57ce35c8", function () {
      api.rerender('57ce35c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/title-editor/TitleEditor.vue"
export default component.exports